/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.BlockTypes {
    angular.module("meevo.plugins.blockTypes", []);
}